module.exports = __webpack_public_path__ + "img/agree.3c188ea.svg";